import $ from 'jquery'
import Utils from '../../modules/utils'
import {isCustomer} from '../cads/is-role'

// Bulk-marks the selected CADs on the new /cads page as best/average/poor seller.
//
// Unlike the old-page save.js (which optimistically increments best_seller_total on
// window.cads), this reconciles the card counts from the totals the backend returns.
// The backend dedupes BestSeller rows, so a repeat save creates no new row — blindly
// incrementing would drift the card count away from the edit popup's live rows.
const saveBestSellerCads2 = (bestOrPoor, myState, mySetState) => {
  let sales_date = $('#mark-as-' + bestOrPoor + '-seller-date').val()

  if (sales_date == '') {
    alert('Please select a date!')
    return
  }

  let {poorSellerAccount, averageSellerAccount, bestSellerAccount, cadIds, cads} = myState

  if (!isCustomer() && ((poorSellerAccount == '' && bestOrPoor == 'poor') || (averageSellerAccount == '' && bestOrPoor == 'average') || (bestSellerAccount == '' && bestOrPoor == 'best'))) {
    alert('Please select a contact!')
    return
  }

  let profile = JSON.parse(localStorage.getItem('user'))
  let user_name = (profile.name != null ? profile.name : profile.email)
  let keys = Object.keys(cadIds)

  // customers can't pick a contact — the modal hides the dropdown — so use their own account
  if (isCustomer()) {
    let customAccess = JSON.parse(localStorage.getItem('customAccess'))
    let account = customAccess != null ? customAccess.quickbooksAccountName : ''
    poorSellerAccount = account
    averageSellerAccount = account
    bestSellerAccount = account
  }

  $('#mark-as-poor-seller-button, #mark-as-average-seller-button, #mark-as-best-seller-button').addClass('loading disabled')

  let data = {
    cad_ids: keys,
    bestOrPoor,
    poorSellerAccount,
    averageSellerAccount,
    bestSellerAccount,
    user_name,
    sales_date
  }

  Utils.post('best_seller', data, (err, res) => {
    $('#mark-as-poor-seller-button, #mark-as-best-seller-button, #mark-as-average-seller-button').removeClass('loading disabled')

    if (err) {
      alert('There was an error when trying to save the ' + bestOrPoor + ' seller.')
      return
    }

    // reconcile counts from the backend-returned totals keyed by cad id
    let totals = (res.data && res.data.totals) || {}
    for (let i = 0; i < cads.length; i++) {
      let t = totals[cads[i].i]
      if (t != null) {
        cads[i].x = t.x
        cads[i].av = t.av
        cads[i].z = t.z
      }
    }

    let successKey
    let newState = {cads, cadIds: {}, allSelected: false}
    if (bestOrPoor == 'best') {
      successKey = 'bestSellerSuccessVisible'
      newState.bestSellerModalOpen = false
    } else if (bestOrPoor == 'average') {
      successKey = 'averageSellerSuccessVisible'
      newState.averageSellerModalOpen = false
    } else {
      successKey = 'poorSellerSuccessVisible'
      newState.poorSellerModalOpen = false
    }
    newState[successKey] = true

    mySetState(newState)

    // the success banner renders near the top of the page — scroll up so it's seen
    window.scrollTo({top: 0, behavior: 'smooth'})

    // auto-dismiss the banner after 30 seconds
    clearTimeout(window.sellerSuccessTimeout)
    window.sellerSuccessTimeout = setTimeout(() => mySetState({[successKey]: false}), 30000)
  })
}

export {saveBestSellerCads2}
